// extracted by mini-css-extract-plugin
export var option = "_48-0";
export var optionCard = "_48-f";
export var optionContent = "_48-g";
export var optionIcon = "_48-i";
export var optionIconBox = "_48-h";
export var optionLabel = "_48-j";
export var optionPill = "_48-m";
export var optionPillBadge = "_48-p";
export var optionPillIcon = "_48-n";
export var optionPillLabel = "_48-o";
export var optionRadio = "_48-k";
export var optionRadioInner = "_48-l";
export var optionReveal = "_48-2";
export var optionRevealDelay0 = "_48-3";
export var optionRevealDelay1 = "_48-4";
export var optionRevealDelay10 = "_48-d";
export var optionRevealDelay11 = "_48-e";
export var optionRevealDelay2 = "_48-5";
export var optionRevealDelay3 = "_48-6";
export var optionRevealDelay4 = "_48-7";
export var optionRevealDelay5 = "_48-8";
export var optionRevealDelay6 = "_48-9";
export var optionRevealDelay7 = "_48-a";
export var optionRevealDelay8 = "_48-b";
export var optionRevealDelay9 = "_48-c";
export var optionSelected = "_48-1";